<div class="layout-wrapper">
  <!-- Visibility controlled by :host media queries in each component's SCSS -->
  <app-header></app-header>
  <app-mobile-header></app-mobile-header>
  
  <div class="layout-container">
    <!-- Sidebar Navigation -->
    <app-sidebar [detailMode]="isDetailPage()" [detailPageInfo]="detailPageInfo()" [assignment]="currentAssignment()" (printAssignmentSheet)="handlePrintAssignmentSheet()"></app-sidebar>

    <!-- Main Content Area -->
    <!-- Mobile: pt-16 (64px for header) | Desktop: p-4 (16px padding) -->
    <div class="content-area p-4 max-md:p-0 max-md:pt-16">
      <!-- Routed page content is projected here. Keep a single <ng-content>
           slot (two conditional slots orphan the router-outlet on navigation);
           detail pages just add the .main-content wrapper class. -->
      <div [class.main-content]="isDetailPage()">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>

<!-- Hidden Print Canvas Section - Available on all pages -->
<!-- hidden on screen, visible only when printing via @media print -->
<div id="printCanvas" class="print-canvas hidden print:block">
  <hr class="print-hr" />
  <div id="printPage" class="print-page" [innerHTML]="assignmentDescription()"></div>
  <hr class="print-hr" />
</div>

<!-- Global Confirmation Dialog for modal/blocking warnings -->
<p-confirmDialog [style]="{width: '450px'}" />

<!-- Global Toast for notifications -->
<p-toast />

<!-- Create Dispatch dialog + appraiser flow: mounted globally so it survives route changes -->
<app-create-dispatch-dialog
  [(visible)]="createDispatchUiService.visible" />

<!-- Dispatch Actions Drawer: global so it can appear on any page after dispatch creation -->
<app-dispatch-actions-drawer
  [(visible)]="dispatchActionsVisible"
  [config]="dispatchActionsConfig()" />
